import { GET_HEADERS } from "../apiclient/common";
import { OIDCClient } from "../apiclient/oidc-client";
import { config } from "../utils/common/constants";

export async function getTeams(token?: string) {
  if (!token) throw Error("MISSING_TOKEN");

  const requestURL = `${config.userServiceUrl}/team`;
  const userServiceColor = config.userServiceColor;

  const headers = { Accept: "application/json", Authorization: `Bearer ${token}` };
  if (userServiceColor) {
    headers["x-fw-color"] = userServiceColor;
  }
  try {
    const response = await fetch(requestURL, { headers });
    const teams = await response.json();

    return teams.filter((team) => !!team?.domain);
  } catch (error) {
    console.error("Couldn't fetch user teams", error);
    return [];
  }
}

export async function getPipelines() {
  try {
    const pipelineServiceUrl = `${config.dealflowUrl}/team/boards`;

    const response = await fetch(pipelineServiceUrl, { headers: await OIDCClient.prepareHeaders(GET_HEADERS) });
    const domains = await response.json();

    const formattedPipelines = domains.reduce((acc, domain) => {
      const { name, id, teams } = domain;
      const options = teams?.map((team) => ({ label: team.name, value: team.id, group: name, groupId: id }));

      acc = acc.concat(options);
      return acc;
    }, []);

    localStorage.setItem("pipelineId", formattedPipelines[0].value);
    localStorage.setItem("dealflowDomainId", formattedPipelines[0].groupId);
    return formattedPipelines;
  } catch (error) {
    console.error("Error while fetching pipelines, ", error);
    return [];
  }
}
